import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/layout/DashboardLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TutorApplications from './pages/TutorApplications';
import UsersList from './pages/UsersList';
import FinancialDashboard from './pages/FinancialDashboard';
import RefundManagement from './pages/RefundManagement';
// Add this import
import SystemMonitoring from './pages/SystemMonitoring';
// Import the component
import AdminManagement from './pages/AdminManagement';

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} 
      />
      
      {/* Only wrap routes that DON'T have their own layout */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tutor-applications"
        element={
          <ProtectedRoute>
            <TutorApplications />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <UsersList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/financial"
        element={
          <ProtectedRoute>
            <FinancialDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/refunds"
        element={
          <ProtectedRoute>
            <RefundManagement />
          </ProtectedRoute>
        }
      />
      {/* Add this route to your existing routes */}
      <Route 
        path="/system-monitoring" 
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <SystemMonitoring />
            </DashboardLayout>
          </ProtectedRoute>
        } 
      />
      
      {/* Add this to your routes */}
      <Route path="/admin-management" element={
        <ProtectedRoute>
          <DashboardLayout>
            <AdminManagement />
          </DashboardLayout>
        </ProtectedRoute>
      } />
      
      {/* Catch all route - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
          <AppRoutes />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
